import React, { ReactElement } from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import { ITemplate } from '../../interfaces/Template'

const ErrorTemplate = ({ children }: ITemplate): ReactElement => {
  document.title = 'Louvre Banque Privée - Erreur'

  return (
    <>
      <Header isLogoutButtonVisible={false} />
      <div className="containerFluid miw0 flexGrow1">
        <div className="row hFullMd">
          <div className="colMd6 offsetMd3 pt5">
            <div className="card textCenter pt5 pb5 px3 px7md">{children}</div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default ErrorTemplate
